import { UserActions } from '@chegg/commerce-utils';
import { CHECKOUT_TYPE_ANNOTATION_DOWNG, CHECKOUT_TYPE_ANNOTATION_JOIN, CHECKOUT_TYPE_ANNOTATION_RESUB, CHECKOUT_TYPE_ANNOTATION_UPG } from '../constants/CheckoutTypeAnnotation';

/**
 * Returns corresponding checkout type annotation based on user action
 * If no action is provided, returns null
 * @param action user action
 * @returns
 */

var UserActionToCheckoutTypeAnnotationMap = new Map([[UserActions.JOIN, CHECKOUT_TYPE_ANNOTATION_JOIN], [UserActions.RESUBSCRIBE, CHECKOUT_TYPE_ANNOTATION_RESUB], [UserActions.DOWNGRADE, CHECKOUT_TYPE_ANNOTATION_DOWNG], [UserActions.UPGRADE, CHECKOUT_TYPE_ANNOTATION_UPG]]);
var getCheckoutTypeAnnotation = function getCheckoutTypeAnnotation(action) {
  if (!action) return null;
  return UserActionToCheckoutTypeAnnotationMap.get(action) || null;
};
export { getCheckoutTypeAnnotation };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/utils/CheckoutTypeAnnotationUtil.js
// module id = 1526
// module chunks = 11